import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/careers/components/CareersDarwinboxEmbed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/CmsImage.tsx");
